import { cableTypesOfCircuit } from "./cableTypesOfCircuit";
import type { CableTypeSplitsOf } from "./types";

// Only the runs he put on more than one type: everything else stays one row, under its one type.
export const cableTypeSplitsOf: CableTypeSplitsOf = ({
  legsByCircuit,
  cableTypeByLegByCircuit,
  circuitTypeOf,
}) =>
  Object.fromEntries(
    Object.entries(cableTypeByLegByCircuit).flatMap(([circuitId, legTypes]) => {
      const legs = legsByCircuit[circuitId];
      if (!legs) return [];
      const shares = cableTypesOfCircuit({ legs, circuitType: circuitTypeOf(circuitId), legTypes });
      return shares.length > 1 ? [[circuitId, shares]] : [];
    }),
  );
